'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = require('../action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
	configuration: {},
	actionListeners: {}
};

exports.default = function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	if (Object.prototype.hasOwnProperty.call(state.actionListeners, action.type)) {
		var conf = Object.keys(state.configuration).reduce(function (acc, curr) {
			if (state.configuration[curr].onAction === action.type) {
				return _extends({}, acc, _defineProperty({}, curr, _extends({}, state.configuration[curr], {
					force: state.configuration[curr].onActionAction
				})));
			}

			return _extends({}, acc, _defineProperty({}, curr, state.configuration[curr]));
		}, {});

		return _extends({}, state, {
			configuration: conf
		});
	}

	switch (action.type) {
		case 'PATH_CHANGE':
			{
				var popupsToClose = {};

				Object.keys(state).filter(function (key) {
					return !initialState[key] && state.configuration[key] && state.configuration[key].closeOnUrlChange === true;
				}).forEach(function (popupId) {
					popupsToClose[popupId] = false;
				});

				return _extends({}, state, popupsToClose);
			}

		case _actionTypes.CMS_COMPONENT_POPUP_SET_STATE_CONFIGURATION:
			{
				return _extends({}, state, {
					configuration: _extends({}, state.configuration, _defineProperty({}, action.payload.id, action.payload.configuration)),
					actionListeners: _extends({}, state.actionListeners, _defineProperty({}, action.payload.configuration.onAction, true))
				});
			}
		case _actionTypes.CMS_COMPONENT_POPUP_TOGGLE:
			{
				var id = action.payload.options && Object.prototype.hasOwnProperty.call(action.payload.options, 'open') ? action.payload.options.open : !state[action.payload.id];
				var removeForce = action.payload.options && action.payload.options.removeForce;
				var configuration = removeForce ? _extends({}, state.configuration, _defineProperty({}, action.payload.id, _extends({}, state.configuration[action.payload.id], {
					force: null
				}))) : state.configuration;

				var keepOpen = Object.keys(state.configuration).filter(function (key) {
					return state.configuration[key].keepOpen && parseInt(key, 10) !== action.payload.id;
				}).reduce(function (acc, key) {
					return _extends({}, acc, _defineProperty({}, key, state[key]));
				}, {});

				return _extends(_defineProperty({
					actionListeners: state.actionListeners,
					configuration: configuration
				}, action.payload.id, id), keepOpen);
			}
		default:
			{
				return state;
			}
	}
};